import {Component, computed, Inject, inject, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {TranslateModule} from '@ngx-translate/core';
import {CommonModule} from '@angular/common';
import {
  DialogCloseButtonComponent,
  PrimaryButtonComponent,
  Q9CreditBalanceWarningComponent,
  SecondaryButtonComponent
} from '@q9elements/ui-kit/components';
import {SessionService, PermissionsService} from '@q9elements/ui-kit/common';
import {CreditWarningDialogData} from './models/credit-warning-dialog-data.interface';
import {get} from 'lodash';

@Component({
  selector: 'app-credit-warning-dialog',
  templateUrl: './credit-warning-dialog.component.html',
  styleUrls: ['./credit-warning-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    TranslateModule,
    DialogCloseButtonComponent,
    PrimaryButtonComponent,
    SecondaryButtonComponent,
    Q9CreditBalanceWarningComponent
  ]
})
export class CreditWarningDialogComponent {
  @ViewChild('creditWarning') creditWarning!: Q9CreditBalanceWarningComponent;
  private readonly sessionService = inject(SessionService);
  private readonly permissionsService = inject(PermissionsService);

  public readonly isFree = this.permissionsService.isFree;
  public readonly hasSubscription = computed(() => {
    const user = this.sessionService.user();

    return !!get(user, 'userInTeam.team.subscription.subscriptionId');
  });

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: CreditWarningDialogData,
    private dialogRef: MatDialogRef<CreditWarningDialogComponent>
  ) {}

  public confirm(): void {
    if (this.creditWarning.canProceed()) {
      this.dialogRef.close(true);
    }
  }

  public cancel(): void {
    this.dialogRef.close(false);
  }
}
